import * as Sentry from "@sentry/vue";
import Maska from "maska";
import moment from "moment";
import { createPinia, PiniaVuePlugin } from "pinia";
import Vue from "vue";
import VueScrollTo from "vue-scrollto";
import cfg from "../config";
import App from "./App.vue";
import { Auth0Plugin } from "./auth";
import { audience, clientId, domain } from "./auth/auth_config.js";
import sentryOpts from "./plugins/sentry";
import vuetify from "./plugins/vuetify";
import router from "./router";
import store from "./store";
//
Vue.use(PiniaVuePlugin);
Vue.use(Maska);
const pinia = createPinia();

Sentry.init(sentryOpts);
Sentry.setTag("buildType", cfg.buildType);
if (cfg.buildType === "PRODUCTION") {
    // disable all logs
    console.log = function() {};
}
Vue.use(VueScrollTo);
Vue.use(Auth0Plugin, {
    domain,
    audience,
    clientId,
    onRedirectCallback: (appState: any) => {
        router.push(appState && appState.targetUrl ? appState.targetUrl : window.location.pathname);
    },
});
moment.locale("ru");
Vue.config.productionTip = false;
Vue.prototype.moment = moment;
Vue.prototype.$screen = window.screen;

declare module "vue/types/vue" {
    interface Vue {
        $auth: any;
    }
}

let isVueTourInstalled = false;
const shouldLoadVueTourForPath = (path: string) => {
    if (!path) { return false; }
    return !path.startsWith("/landing") && !path.startsWith("/OAuthLogin");
};

const ensureVueTourInstalled = async (path: string) => {
    if (isVueTourInstalled || !shouldLoadVueTourForPath(path)) { return; }
    try {
        const { default: VueTour } = await import("vue-tour");
        require("vue-tour/dist/vue-tour.css");
        Vue.use(VueTour);
        isVueTourInstalled = true;
    } catch (e) {
        console.error("Failed to load vue-tour plugin", e);
    }
};

const bootstrap = async () => {
    new Vue({
        router,
        store,
        vuetify,
        pinia,
        render: (h) => h(App),
    }).$mount("#app");

    void ensureVueTourInstalled(window.location.pathname);
    router.afterEach((to) => {
        void ensureVueTourInstalled(to.path);
    });
};

void bootstrap();
